/**
 * WhatsApp usage panel (ADR-041): per WhatsApp number per month, what was
 * delivered and roughly what Meta will charge the workspace for it. Reporting
 * only - Meta bills the workspace directly (ADR-029).
 */
/** Service (non-template) messages free per number per month (Meta, from Oct 2026). */
export const WHATSAPP_FREE_SERVICE_MESSAGES = 1000;
/** GST Meta adds to an Indian business's invoice. */
export const WHATSAPP_GST_RATE = 0.18;
/** Free service messages used (of the allowance) at which a number's admins are told. */
export const WHATSAPP_FREE_SERVICE_ALERTS = [800, 1000];
/** Categories a rate can be set for (the ones Meta charges). */
export const WHATSAPP_RATE_CATEGORIES = [
    { category: 'marketing', label: 'Marketing templates' },
    { category: 'utility', label: 'Utility templates' },
    { category: 'authentication', label: 'Authentication templates' },
    { category: 'service', label: 'Service messages (after the free 1,000)' },
];
/**
 * Meta's pricing markets (its rate card: a recipient's country decides the
 * price). Single countries, then Meta's regional groups; `OTHER` is the
 * fallback rate for any country without its own.
 */
export const WHATSAPP_PRICING_MARKETS = [
    { code: 'IN', label: 'India' },
    { code: 'AE', label: 'United Arab Emirates' },
    { code: 'SA', label: 'Saudi Arabia' },
    { code: 'GB', label: 'United Kingdom' },
    { code: 'NA', label: 'North America (US, Canada)' },
    { code: 'PK', label: 'Pakistan' },
    { code: 'ID', label: 'Indonesia' },
    { code: 'MY', label: 'Malaysia' },
    { code: 'EG', label: 'Egypt' },
    { code: 'IL', label: 'Israel' },
    { code: 'TR', label: 'Turkey' },
    { code: 'NG', label: 'Nigeria' },
    { code: 'ZA', label: 'South Africa' },
    { code: 'DE', label: 'Germany' },
    { code: 'FR', label: 'France' },
    { code: 'IT', label: 'Italy' },
    { code: 'ES', label: 'Spain' },
    { code: 'NL', label: 'Netherlands' },
    { code: 'RU', label: 'Russia' },
    { code: 'BR', label: 'Brazil' },
    { code: 'MX', label: 'Mexico' },
    { code: 'AR', label: 'Argentina' },
    { code: 'CL', label: 'Chile' },
    { code: 'CO', label: 'Colombia' },
    { code: 'PE', label: 'Peru' },
    { code: 'REST_MIDDLE_EAST', label: 'Rest of Middle East' },
    { code: 'REST_APAC', label: 'Rest of Asia Pacific' },
    { code: 'REST_AFRICA', label: 'Rest of Africa' },
    { code: 'REST_WESTERN_EUROPE', label: 'Rest of Western Europe' },
    { code: 'REST_CEE', label: 'Rest of Central & Eastern Europe' },
    { code: 'REST_LATAM', label: 'Rest of Latin America' },
    { code: 'OTHER', label: 'Other countries (fallback)' },
];
//# sourceMappingURL=whatsapp-usage.js.map